import type { Middleware } from '@reduxjs/toolkit';
import { isPending, isFulfilled, isRejected } from '@reduxjs/toolkit';
import { changeLoadingState } from 'app/settings/slices';
import { RTKQueryMeta } from 'types';

let activeRequests = 0;

export const loadingMiddleware: Middleware = () => (next) => (action: unknown) => {
  const skipGlobalLoading = (action as { meta?: RTKQueryMeta }).meta?.arg?.originalArgs?.skipGlobalLoading;

  if (!skipGlobalLoading) {
    if (isPending(action)) {
      activeRequests += 1;

      if (activeRequests === 1) {
        next(changeLoadingState(true));
      }
    }

    if (isFulfilled(action) || isRejected(action)) {
      activeRequests = Math.max(0, activeRequests - 1);

      if (activeRequests === 0) {
        next(changeLoadingState(false));
      }
    }
  }

  return next(action);
};
